define(
  'dependenciesLoader',[],
  () => {
    'use strict';

    const marketsDropDownList = document.querySelector('[data-component="markets-list"]');

    /**
    * @private
    * initMap: loads the interactive map
    *
    */
    function init() {
      const dependenciesModuleName = document.querySelector('[data-ismobiledevice="true"]')
        ? 'builderShowcaseSectionsUtilsMobile'
        : 'builderShowcaseSectionsUtilsDesktop';

      require([dependenciesModuleName]);
      if (marketsDropDownList) {
        marketsDropDownList.removeAttribute('disabled');
      }
    }

    if (document.readyState === 'complete') {
      init();
    } else {
      window.addEventListener('load', init);
    }
  }
);

